import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  matrixQueries,
  updateMatrix,
  type UpdateMatrixInput,
} from "@/domains/matrix";

type UpdateMatrixParams = UpdateMatrixInput & { collectionId: string };

// Backs the toolbar's rename; the PATCH route also accepts `question`.
export function useUpdateMatrix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ collectionId, ...input }: UpdateMatrixParams) =>
      updateMatrix(collectionId, input),
    onSuccess: (_data, { collectionId }) => {
      void queryClient.invalidateQueries(matrixQueries.lists());
      void queryClient.invalidateQueries(matrixQueries.detail(collectionId));
    },
  });
}
